import {
  Delta360MembershipCardMocks,
  DiamondMembershipCardMocks,
  GoldMembershipCardMocks,
  PlatinumMembershipCardMocks,
  SilverMembershipCardMocks,
  SkyMilesMembershipCardMocks
} from '../../membership-card/mocks/membership-card.mocks';
import { QuickLinks } from '../models/quick-links.interfaces';

export const NewMemberQuickLinksMocks: QuickLinks = {
  title: 'SkyMiles Quick Links',
  cards: [
    {
      id: 'skyMilesDigitalCard',
      type: 'small',
      content: {
        title: 'SkyMiles Digital Card'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-skymiles.png',
        alt: 'SkyMiles Digital Card image'
      },
      tag: {
        title: 'SKYMILES MEMBER',
        subtitle: '#8006270311'
      },
      action: {
        type: 'notify',
        link: {
          label: 'View / Print',
          url: '/membership-card'
        }
      }
    },
    {
      id: 'requestMissingMiles',
      type: 'small',
      content: {
        title: 'Request Missing Miles'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/missing-miles-card.svg',
        alt: 'Request Missing Miles image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Request Missing Miles',
          url: '/acctactvty/mileagecredit.action'
        }
      }
    },
    {
      id: 'finishSettingUpYourProfile',
      type: 'small',
      content: {
        title: 'Finish Setting Up Your Profile'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/setup-profile-card.svg',
        alt: 'Finish Setting Up Your Profile image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Finish Setting Up Your Profile',
          url: '/myprofile/personal-details'
        }
      }
    },
    {
      id: 'certificates',
      type: 'small',
      content: {
        title: 'Vouchers, eCredits & Certificates'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/drinks-voucher-card.svg',
        alt: 'Vouchers, eCredits & Certificates image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Vouchers, eCredits & Certificates',
          url: '/myprofile/certificates'
        }
      }
    }
  ],
  membershipCard: Delta360MembershipCardMocks,
  disabled: false,
  loaded: true
};

export const SkymilesMemberQuickLinksMocks: QuickLinks = {
  title: 'SkyMiles Quick Links',
  cards: [
    {
      id: 'skyMilesDigitalCard',
      type: 'small',
      content: {
        title: 'SkyMiles Digital Card'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-skymiles.png',
        alt: 'SkyMiles Digital Card image'
      },
      tag: {
        title: 'SKYMILES MEMBER',
        subtitle: '#8006270311'
      },
      action: {
        type: 'notify',
        link: {
          label: 'View / Print',
          url: '/membership-card'
        }
      }
    },
    {
      id: 'learnAbouttheSkyMilesProgram',
      type: 'small',
      content: {
        title: 'View My Promotions'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/promotions-card.svg',
        alt: 'View My Promotions image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'View My Promotions',
          url: '/mypromos/eligible'
        }
      }
    },
    {
      id: 'setUpYourProfile',
      type: 'small',
      content: {
        title: 'Manage Saved Payments'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-promo-card.svg',
        alt: 'Manage Saved Payments image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Saved Payments',
          url: '/myprofile/payment-methods'
        }
      }
    },
    {
      id: 'certificates',
      type: 'small',
      content: {
        title: 'Vouchers, eCredits & Certificates'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/drinks-voucher-card.svg',
        alt: 'Vouchers, eCredits & Certificates image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Vouchers, eCredits & Certificates',
          url: '/myprofile/certificates'
        }
      }
    }
  ],
  membershipCard: SkyMilesMembershipCardMocks,
  disabled: false,
  loaded: true
};

export const SilverMedallionQuickLinksMocks: QuickLinks = {
  title: 'SkyMiles Quick Links',
  cards: [
    {
      id: 'skyMilesDigitalCard',
      type: 'small',
      content: {
        title: 'SkyMiles Digital Card'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-silver.png',
        alt: 'SkyMiles Digital Card image'
      },
      tag: {
        title: 'SILVER MEDALLION',
        subtitle: '#8006270311'
      },
      action: {
        type: 'notify',
        link: {
          label: 'View / Print',
          url: '/membership-card'
        }
      }
    },
    {
      id: 'learnAboutMedallionUpgrades',
      type: 'small',
      content: {
        title: 'View My Promotions'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/promotions-card.svg',
        alt: 'View My Promotions image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'View My Promotions',
          url: '/mypromos/eligible'
        }
      }
    },
    {
      id: 'requestComplimentaryUpgradesinYourProfile',
      type: 'small',
      content: {
        title: 'Manage Saved Payments'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-promo-card.svg',
        alt: 'Manage Saved Payments image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Saved Payments',
          url: '/myprofile/payment-methods'
        }
      }
    },
    {
      id: 'certificates',
      type: 'small',
      content: {
        title: 'Vouchers, eCredits & Certificates'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/drinks-voucher-card.svg',
        alt: 'Vouchers, eCredits & Certificates image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Vouchers, eCredits & Certificates',
          url: '/myprofile/certificates'
        }
      }
    }
  ],
  membershipCard: SilverMembershipCardMocks,
  disabled: false,
  loaded: true
};

export const GoldMedallionQuickLinksMocks: QuickLinks = {
  title: 'SkyMiles Quick Links',
  cards: [
    {
      id: 'skyMilesDigitalCard',
      type: 'small',
      content: {
        title: 'SkyMiles Digital Card'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-gold.png',
        alt: 'SkyMiles Digital Card image'
      },
      tag: {
        title: 'GOLD MEDALLION',
        subtitle: '#8006270311'
      },
      action: {
        type: 'notify',
        link: {
          label: 'View / Print',
          url: '/membership-card'
        }
      }
    },
    {
      id: 'requestComplimentaryUpgradesinYourProfile',
      type: 'small',
      content: {
        title: 'View My Promotions'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/promotions-card.svg',
        alt: 'View My Promotions image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'View My Promotions',
          url: '/mypromos/eligible'
        }
      }
    },
    {
      type: 'small',
      content: {
        title: 'Manage Saved Payments'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-promo-card.svg',
        alt: 'Manage Saved Payments image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Saved Payments',
          url: '/myprofile/payment-methods'
        }
      }
    },
    {
      id: 'certificates',
      type: 'small',
      content: {
        title: 'Vouchers, eCredits & Certificates'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/drinks-voucher-card.svg',
        alt: 'Vouchers, eCredits & Certificates image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Vouchers, eCredits & Certificates',
          url: '/myprofile/certificates'
        }
      }
    }
  ],
  membershipCard: GoldMembershipCardMocks,
  disabled: false,
  loaded: true
};

export const PlatinumMedallionQuickLinksMocks: QuickLinks = {
  title: 'SkyMiles Quick Links',
  cards: [
    {
      id: 'skyMilesDigitalCard',
      type: 'small',
      content: {
        title: 'SkyMiles Digital Card'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-platinum.png',
        alt: 'SkyMiles Digital Card image'
      },
      tag: {
        title: 'PLATINUM MEDALLION',
        subtitle: '#8006270311'
      },
      action: {
        type: 'notify',
        link: {
          label: 'View / Print',
          url: '/membership-card'
        }
      }
    },
    {
      id: 'learnAboutMedallionUpgrades',
      type: 'small',
      content: {
        title: 'Manage Sky Club Membership'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-card.svg',
        alt: 'Manage Sky Club Membership image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Sky Club Membership',
          url: '/skyclub/skyclubPaymentPlan_redirectToPaymentConfirmation.action'
        }
      }
    },
    {
      id: 'checkOutChoiceBenefits',
      type: 'small',
      content: {
        title: 'Manage Saved Payments'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-silver-promo-card.svg',
        alt: 'Manage Saved Payments image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Saved Payments',
          url: '/myprofile/payment-methods'
        }
      }
    },
    {
      id: 'requestComplimentaryUpgradesinYourProfile',
      type: 'small',
      content: {
        title: 'Manage Choice Benefits'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/choice-benefits-card.svg',
        alt: 'Manage Choice Benefits image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Choice Benefits',
          url: '/en_US/skymiles/medallion-program/choice-benefits/choice-benefits'
        }
      }
    }
  ],
  membershipCard: PlatinumMembershipCardMocks,
  disabled: false,
  loaded: true
};

export const DiamondMedallionQuickLinksMocks: QuickLinks = {
  title: 'SkyMiles Quick Links',
  cards: [
    {
      id: 'skyMilesDigitalCard',
      type: 'small',
      content: {
        title: 'SkyMiles Digital Card'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-diamond.png',
        alt: 'SkyMiles Digital Card image'
      },
      tag: {
        title: 'DIAMOND MEDALLION',
        subtitle: '#8006270311'
      },
      action: {
        type: 'notify',
        link: {
          label: 'View / Print',
          url: '/membership-card'
        }
      }
    },
    {
      id: 'learnAboutMedallionUpgrades',
      type: 'small',
      content: {
        title: 'Manage Sky Club Membership'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-card.svg',
        alt: 'Manage Sky Club Membership image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Sky Club Membership',
          url: '/skyclub/skyclubPaymentPlan_redirectToPaymentConfirmation.action'
        }
      }
    },
    {
      id: 'checkOutChoiceBenefits',
      type: 'small',
      content: {
        title: 'Manage Saved Payments'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-silver-promo-card.svg',
        alt: 'Manage Saved Payments image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Saved Payments',
          url: '/myprofile/payment-methods'
        }
      }
    },
    {
      id: 'requestComplimentaryUpgradesinYourProfile',
      type: 'small',
      content: {
        title: 'Manage Choice Benefits'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/choice-benefits-card.svg',
        alt: 'Manage Choice Benefits image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Choice Benefits',
          url: '/en_US/skymiles/medallion-program/choice-benefits/choice-benefits'
        }
      }
    }
  ],
  membershipCard: DiamondMembershipCardMocks,
  disabled: false,
  loaded: true
};

export const Delta360QuickLinksMocks: QuickLinks = {
  title: 'SkyMiles Quick Links',
  cards: [
    {
      id: 'skyMilesDigitalCard',
      type: 'small',
      content: {
        title: 'SkyMiles Digital Card'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-card-360.png',
        alt: 'SkyMiles Digital Card image'
      },
      tag: {
        title: 'DELTA 360',
        subtitle: '#8006270311'
      },
      action: {
        type: 'notify',
        link: {
          label: 'View / Print',
          url: '/membership-card'
        }
      }
    },
    {
      id: 'learnAboutMedallionUpgrades',
      type: 'small',
      content: {
        title: 'Manage Sky Club Membership'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-card.svg',
        alt: 'Manage Sky Club Membership image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Sky Club Membership',
          url: '/skyclub/skyclubPaymentPlan_redirectToPaymentConfirmation.action'
        }
      }
    },
    {
      id: 'checkOutChoiceBenefits',
      type: 'small',
      content: {
        title: 'Manage Saved Payments'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-silver-promo-card.svg',
        alt: 'Manage Saved Payments image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Saved Payments',
          url: '/myprofile/payment-methods'
        }
      }
    },
    {
      id: 'checkOutChoiceBenefits',
      type: 'small',
      content: {
        title: 'Manage Choice Benefits'
      },
      image: {
        src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/choice-benefits-card.svg',
        alt: 'Manage Choice Benefits image'
      },
      action: {
        type: 'caret',
        link: {
          label: 'Manage Choice Benefits',
          url: '/en_US/skymiles/medallion-program/choice-benefits/choice-benefits'
        }
      }
    }
  ],
  membershipCard: Delta360MembershipCardMocks,
  disabled: false,
  loaded: true
};
